<template>
  <div class="menuBody" style="width:100%">
    
    <DailyChargeTree @DailyChargeTree="getMsgFormSon" />
        <DailyChargeDialog :param="diaLogData" @MergeDate="MergeDate" @Visible="VisibleDialog" @MergeObject="MergeObject" ref="DailyChargeDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div class="PageTabs">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="应收列表" name="first">应收列表</el-tab-pane>
                <el-tab-pane label="其他收费列表" name="second">其他收费列表</el-tab-pane>
                <el-tab-pane label="收款情况查询" name="third">收款情况查询</el-tab-pane>
              </el-tabs>
            </div>
            <div class="PageHead">
                <div style="float:right;margin-right:10px;margin-top:-10px">
                    <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cp:dailyCp:updatebills'" @click="ReceiptSave()">收款确定</el-button>
                </div>
                <div style="float:right;margin-right:10px;margin-top:-10px">
                <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cp:dailyCp:updatebills'" @click="ElseCharge()">其他收费</el-button>
                </div>
                <div style="float:right;margin-right:10px;margin-top:-10px">
                    <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" @click="toggleSelection([tableData])">全部已到期应收款</el-button>
                </div>
                <div style="float:right;margin-right:10px;margin-top:-10px">
                <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:cp:dailyCp:merge'" @click="MergerPayment()">合并收款</el-button>
                </div>
                <div style="float:right;margin-right:10px;margin-top:-10px">
                    <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;display:none" v-Jurisdiction="'expense:web:cp:dailyCp:updatefixinvoice'" @click="BatchQuota()">批量定额发票</el-button>
                </div>
            </div>
            <div style="width:150px;float:left;margin-right:15px;">
                 <el-input placeholder="业户地址" size="small"   v-model="roomName" disabled></el-input>
            </div>
            <div style="width:250px;float:left;margin-right:15px;">
                 <el-input placeholder="业户名称" size="small"   v-model="customerName" disabled></el-input>
            </div>
            <div style="width:120px;float:left;margin-right:15px;">
                 <el-input placeholder="房屋性质" size="small"   v-model="roomProperty" disabled ></el-input>
            </div>
            <div style="width:120px;float:left;margin-right:15px;">
                 <el-input placeholder="建筑面积" size="small"   v-model="buildArea" disabled></el-input>
            </div>         
             <div style="float:right;margin-right:10px">
               <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cp:dailyCp:selectInvioce'"  @click="Examine()">票据查看</el-button>
            </div>
             <div style="float:right;margin-right:10px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:cp:dailyCp:reopenInvoice'" @click="Reopen()">票据重开</el-button>
            </div>
            <div style="float:right;margin-right:10px">
               <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cp:dailyCp:scarpInvoice'" @click="Cancellation()">票据作废</el-button>
            </div>
              <el-table ref="multipleTable" tooltip-effect="light"  :data="tableData" :height="ListHeight" @select-all="CheckAll"  @selection-change="BillNucleu" v-loading="loading"
  style="overflow-y: scroll;float:right;margin-top:20px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column label="序号" type="index" width="60"></el-table-column>
    <el-table-column type="selection" width="55" style="text-align: center;"></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeItem.feeName" label="项目" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjCny" label="应收年月" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjJe" label="应收金额" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeItem.subjectsCode" label="对应科目" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="ext2" label="计费单价" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="ext1" label="计费方式" >
            <template slot-scope="scope">
        <el-tag v-if="scope.row.ext1=='0'" >按月收费</el-tag>
        <el-tag v-if="scope.row.ext1=='1'" >单价 * 面积</el-tag>
      </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="账单备注" ></el-table-column>
    <el-table-column fixed="right" label="操作">
    <template slot-scope="scope">
         <!-- <el-button @click="delMenu(scope.row)" type="danger" v-Jurisdiction="'expense:web:cp:dailyCp:adjustAdd'" icon="el-icon-delete" circle size="small" title="拆分"></el-button> -->
        <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" v-Jurisdiction="'expense:web:cp:dailyCp:delete'" circle size="small" title="作废"></el-button>
    </template>
    </el-table-column>
  </el-table>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import DailyChargeDialog from "../common/DailyChargeDialog";
import DailyChargeTree from "../common/DailyChargeTree.vue";

export default {
  name: "DailyCharge",
  components: {DailyChargeDialog,DailyChargeTree},
  data() {
    return {
      activeName: 'first',
      CheckArr:[],
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillNumber:"",
        BillStartNum:"",
        BillEndNum:"",
        groupName:"",
        UpCourseCode:"",
        CourseCode:"",
      tableData: [],
      options: [],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      taxRateval:"",
      ListHeight:"500px",
      customerName:"",
      roomProperty:"",
      buildArea:"",
      roomName:"",
      BillTypeList:[],
      allSelect: false,
      osDataget:[],
      taxRatelength:0,
      ItemTraverse:[],
      ObjectData:{},
      isDaily:"0",
    }
  },
   watch: {
    //   // 监听路由变化
     "$route.path": function(newVal, oldVal) {
       if(`${newVal}` == "/charge/bills/dailyIndex"){
       this.activeName = "first"
       }else if(`${newVal}` == "/cha/ElseCharge"){
        this.activeName = "second"
       }else if(`${newVal}` == "/cha/ChargSituation"){
        this.activeName = "third"
       }
     }
  },
  methods: {
      handleClick(tab, event) {
        if(this.activeName == "first"){
          this.activeName = "first"
          this.$router.push({name: 'DailyCharge'})
        }else if(this.activeName == "second"){
          this.activeName = "second"
          this.$router.push({name: 'ElseCharge'})
        }else if(this.activeName == "third"){
          this.activeName = "third"
          this.$router.push({name: 'ChargSituation'})
        }
      },
    toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
    },
    delMenu(val){
      // console.log(val)
  this.$confirm('是否确认要作废该账单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
 this.$http.get(this.$requestUrl.DELETE_BILLS+"?id="+val.id).then((res)=>{
        let result = res.data;
        if (200 === result.code) {
          this.loading = true
          this.ShareList()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
      BillNucleu(val){
        // console.log(val)
        let arr = []
        for(let value of this.ItemTraverse){
        for(let res of val){
          if(res.subname == value.feeName){
            if(value.feeCategory == "01"){
              this.isDaily = "0"
            }else{
              this.isDaily = "1"
            }
           res.display = true
          res.asarr = [value.feeCategory,value.feeCode]
          }
        }
        }
        for(let res of val){
          arr.push(res.id)
        }
          this.taxRateval = val
          this.billIds = arr
          this.taxRatelength= this.taxRateval.length
      },
      MergeObject(data){
         this.ObjectData= data
      },
      MergeDate(data){
        this.ergodicity(data)
        this.tableData = data
        this.loading = false
      },
    getMsgFormSon(data){
        if(data.roomId){
          this.roomId = data.roomId
          this.roomName = data.roomName
          this.customerId = data.customerId
          this.customerName = data.customerName
          this.roomProperty = data.roomProperty
          this.buildArea = data.buildArea
          this.ShareList()
        }else if(data.orgId != null){
          this.projectId = data.id
        }
      this.AllData = data
    },
    handleSizeChange(val) {
      this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    ShareList(){
          let PageSize = {
            "customerId":this.customerId,// 业主ID
            "projectId":this.projectId,
      }
        this.$http.post(this.$requestUrl.POST_RECEIVABLE_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.ergodicity(data.data)
            this.tableData = data.data
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    ergodicity(res){
      for(let val of res){
        for(let vas of this.options){
          if(vas.value == val.feeitemCode){
            val.taxRateName = vas.taxRateName
            val.subname = vas.label
            val.maintenanceCost = vas.maintenanceCost
          }
        }
      }
    },
    Cancellation(){
      this.$refs.DailyChargeDialog.title = "票据作废";
      this.$refs.DailyChargeDialog.dialogVisible = true; 
      this.$refs.DailyChargeDialog.BillTypeList = this.BillTypeList; 
      this.$refs.DailyChargeDialog.isType = "4"
            let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"
          }
        let row ={}
        row.obj = obj
        this.$refs.DailyChargeDialog.formLabelAlign= row;
    },
    Reopen(){
      this.$refs.DailyChargeDialog.title = "票据重开";
      this.$refs.DailyChargeDialog.dialogVisible = true; 
      this.$refs.DailyChargeDialog.BillTypeList = this.BillTypeList; 
      this.$refs.DailyChargeDialog.isType = "5"
            let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"
          }
        let row ={}
        row.obj = obj
        this.$refs.DailyChargeDialog.formLabelAlign= row;
    },
    Examine(){
      this.$refs.DailyChargeDialog.title = "票据查看";
      this.$refs.DailyChargeDialog.BillTypeList = this.BillTypeList; 
      this.$refs.DailyChargeDialog.dialogVisible = true; 
      this.$refs.DailyChargeDialog.isType = "6"
            let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"
          }
          let row ={}
        row.obj = obj
         this.$refs.DailyChargeDialog.formLabelAlign= row;
    },
    BatchQuota(){
      // 批量定额发票
      if(this.customerId!=undefined){
        this.$refs.DailyChargeDialog.title = "批量定额票据";
        this.$refs.DailyChargeDialog.BillTypeList = this.BillTypeList; 
        this.$refs.DailyChargeDialog.projectId = this.projectId; 
        this.$refs.DailyChargeDialog.customerId = this.customerId;
        this.$refs.DailyChargeDialog.dialogVisible = true;
        this.$refs.DailyChargeDialog.isType = "0"
        let obj = {
                  "NoteBook":"票据簿",
                  "NoteNum":"票据号",
                  "ChargeItem":"收费项目",
            }
        let row ={}
        row.obj = obj
        this.$refs.DailyChargeDialog.formLabelAlign= row;
      }else{
        this.$message({
          showClose: true,
          message: '请选择业主！',
          type: 'warning'
        });
      }
    },
    ElseCharge(){
      // 其他收费票据信息
    if(this.customerName != null && this.customerName != "" ){
       let user = localStorage.getItem("userName")
        this.user = JSON.parse(user)
        let row = {
                  "name":this.customerName,
                  "address":this.roomName,
                  "payuserName":this.user.name,
        }
       row.obj = {
                  "BillType":"票据类型",
                  "NoteBook":"票据簿",
                  "NoteNum":"票据号",
                  "payer":"付款人",
                  "DutyNum":"税号",
                  "Account":"账号",
                  "Site":"地址",
                  "total":"合计",
                  "income":"合计收入",
                  "amount":"合计税额",
                  "remarks":"备注",
                  "receipt":"收款日期",
                  "mode":"收款方式",
                  "hint":"提示用户电子发票有附加信息:",
                  "invoice":"开票人",
                  "proceeds":"收款人",
                  "invoiceDate":"开票日期",
                }
            this.$refs.DailyChargeDialog.title = "其他收费票据信息";
            this.$refs.DailyChargeDialog.dialogVisible = true; 
            this.$refs.DailyChargeDialog.isType = "2"
            this.$refs.DailyChargeDialog.projectIdStr = this.projectId
            this.$refs.DailyChargeDialog.customerIdStr = this.customerId
            this.$refs.DailyChargeDialog.billIdStr = this.billIds
            this.$refs.DailyChargeDialog.isDaily = this.isDaily
            this.$refs.DailyChargeDialog.formLabelAlign = row  
            this.$refs.DailyChargeDialog.tableData = []
            this.$refs.DailyChargeDialog.BillDateTime = ""
            this.$refs.DailyChargeDialog.ReceiptTime = ""
            this.$refs.DailyChargeDialog.receiptTypevalue = ""
             this.$refs.DailyChargeDialog.BillBookvalue = ""
               this.$refs.DailyChargeDialog.BillTypevalue = ""
                  this.$refs.DailyChargeDialog.BillNumvalue = ""
        }else{
          this.$message({
              message: '请选择业主！',
              type: 'warning'
          });
        }
    },
    CheckAll(val){
      this.CheckArr = val
    },
     weight(){
        // 票据类型 
        this.$http.get("/charge/web/chargeInvoiceInhouse/selectInvioce").then((res)=>{
          let date = res.data.data
          let arr =[]
          if(date!=null){
            for(let val of date){
            let obj = {
              "BillTypevalue":val.typeId,
              "BillTypelabel":val.typeName
            }
            arr.push(obj)
            }
          }
          this.BillTypeList = arr
        })
      },
      RequestData(obj,valT){
        this.$http.post(this.$requestUrl.POST_DAILFORM,obj).then((res)=>{
                  for(let val of res.data.data.billslists){
                      val.unitPrice = val.num*val.price
                  }
            let obj = {
                  "BillType":"票据类型",
                  "NoteBook":"票据簿",
                  "NoteNum":"票据号",
                  "payer":"付款人",
                  "DutyNum":"税号",
                  "Account":"账号",
                  "Site":"地址",
                  "total":"合计",
                  "income":"合计收入",
                  "amount":"合计税额",
                  "remarks":"备注",
                  "receipt":"收款日期",
                  "mode":"收款方式",
                  "hint":"提示用户电子发票有附加信息:",
                  "invoice":"开票人",
                  "proceeds":"收款人",
                  "invoiceDate":"开票日期",
            }
                  let user = localStorage.getItem("userName")
                  this.user = JSON.parse(user)
            res.data.data.payuserName= this.user.name
            res.data.data.obj = obj
            this.traversal(res.data.data.billslists)
            this.$refs.DailyChargeDialog.title = valT;
            this.$refs.DailyChargeDialog.dialogVisible = true; 
            this.$refs.DailyChargeDialog.taxRatelength = res.data.data.billslists.length
            this.$refs.DailyChargeDialog.tableData = res.data.data.billslists
            this.$refs.DailyChargeDialog.isType = "3"
            this.$refs.DailyChargeDialog.formLabelAlign = res.data.data
            this.$refs.DailyChargeDialog.projectIdStr = this.projectId
            this.$refs.DailyChargeDialog.customerIdStr = this.customerId
            this.$refs.DailyChargeDialog.billIdStr = this.billIds
            this.$refs.DailyChargeDialog.isDaily = this.isDaily
            this.$refs.DailyChargeDialog.hjje = res.data.data.hjje
            this.$refs.DailyChargeDialog.BillDateTime = ""
            this.$refs.DailyChargeDialog.ReceiptTime = ""
            this.$refs.DailyChargeDialog.receiptTypevalue = ""
            this.$refs.DailyChargeDialog.BillBookvalue = ""
            this.$refs.DailyChargeDialog.BillTypevalue = ""
            this.$refs.DailyChargeDialog.BillNumvalue = ""
        })
      },
      traversal(res){
        for(let val of res){
          for(let date of this.ItemTraverse){
            if(val.feeitemCode == date.feeCode){
              val.display = true
              val.asarr = [date.feeCategory,date.feeCode]
            }
          }
        }
      },
      ReceiptSave(){
        // console.log(this.taxRateval)
        if(this.taxRateval.length>=1){
          let arr = this.taxRateval
          if(arr[0].name){
           let obj = {
            "roomIds":this.ObjectData.roomIds,
            "projectid":this.ObjectData.projectIds[0],
            "customerId":this.ObjectData.customerIds,
            "billsIds":this.billIds,
            "isDaily":this.isDaily,
          }
          this.RequestData(obj,"收款确定")
          }else{
            let arr = []
            arr.push(this.roomId)
            let array = []
            array.push(this.customerId)
          let obj = {
            "roomIds":arr,
            "projectid":this.projectId,
            "customerId":array,
            "billsIds":this.billIds,
            "isDaily":this.isDaily,
          }
          this.RequestData(obj,"收款确定")
          }
        }else{
          this.$message({
              message: '请选择应收列表！',
              type: 'warning'
          });
        }
      },
    MergerPayment(){
      this.$http.get(this.$requestUrl.GET_FLOOR_TREE).then((res) => {
        let data = res.data.data;
        if(res.data.code == 200){
          if(data == null){
          }else{
            this.osDataget = data
            this.$refs.DailyChargeDialog.title = "合并收款";
            this.$refs.DailyChargeDialog.dialogVisible = true; 
            this.$refs.DailyChargeDialog.isType = "1"
            this.$refs.DailyChargeDialog.osDataget = data
          }           
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
        ItemWeight(){
          this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
           let result = res.data;
           let arr = []
           for(let val of result.data){
                let obj = {
                    "value":val.feeCode,
                    "label":val.feeName,
                    "type":val.id,
                    "subjectsCode":val.subjectsCode,
                    "subjectsName":val.subjectsName,
                    "taxRateCode":val.taxRateCode,
                    "taxRateName":val.taxRateName,
                    "maintenanceCost":val.maintenanceCost
                }
               arr.push(obj)
           }
           this.options = arr
           
        })
    },
          ChargeItem(){
        // 收费项目
        this.$http.get("/charge/web/chargeFeeitem/getAllFeeItem").then((res)=>{
          // console.log(res)
          let data = res.data.data
          // console.log(data)
          this.ItemTraverse = data
        })
      },
      VisibleDialog(data){
        if(data === false){
          this.ShareList()
        }
      }

  },
  mounted() {
    this.ChargeItem()
    this.weight()
    this.ItemWeight()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.PageHead{
  width:100%;height:30px;margin-top:10px;margin-bottom:15px;
   -moz-user-select: none;
            -khtml-user-select: none;
            user-select: none;
}
.el-tabs__content{
  display: none;
}
.PageTabs{
  width: 100%;
  margin-bottom: 20px;
  .el-tabs__nav-scroll{
    border:none
  }
}
.el-cascader-node__label{
  color: black;
}
</style>